import React from "react";
import { usePermissions } from "@/context/PermissionsProvider";

interface CanProps {
  /** Permission name, e.g. "role:manage" */
  permission: string;
  /** Rendered when the user has the permission */
  children: React.ReactNode;
  /** Optional fallback rendered when the user does NOT have the permission */
  fallback?: React.ReactNode;
}

/**
 * Conditionally renders `children` only when the current user has the
 * specified permission.  Uses the PermissionsContext — must be rendered
 * inside a `<PermissionsProvider>`.
 *
 * @example
 * <Can permission="role:manage">
 *   <button onClick={createRole}>Create Role</button>
 * </Can>
 */
export const Can: React.FC<CanProps> = ({ permission, children, fallback = null }) => {
  const { can } = usePermissions();
  return can(permission) ? <>{children}</> : <>{fallback}</>;
};
